import request from 'gh-qqnews-request'
import { apiUrl } from '@/core/config'

request.defaults.baseURL = apiUrl

/**
 * http://tnpm.oa.com/package/gh-qqnews-request
 * https://www.npmjs.com/package/gh-qqnews-request
 *
 * request 可以请求一个相对地址，baseURL 在 @/common/utils/request 有配置
 * 也可以请求一个绝对地址，此时 baseURL 失效
 */

export default request
